"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    headerEncode: function() {
        return headerEncode;
    },
    hostFromBaseUrl: function() {
        return hostFromBaseUrl;
    }
});
var headerEncode = function(obj) {
    return btoa(JSON.stringify(obj));
};
var hostFromBaseUrl = function(baseUrl) {
    return baseUrl.replace("https://", "").replace("/graphql", "").replace("realtime", "");
};

//# sourceMappingURL=utils.js.map